import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=12820cb8&scoped=true"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"
import style0 from "./Views.vue?vue&type=style&index=0&id=12820cb8&lang=scss"
import style1 from "./Views.vue?vue&type=style&index=1&id=12820cb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12820cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/minhochoi/projects/MAPPING/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12820cb8')) {
      api.createRecord('12820cb8', component.options)
    } else {
      api.reload('12820cb8', component.options)
    }
    module.hot.accept("./Views.vue?vue&type=template&id=12820cb8&scoped=true", function () {
      api.rerender('12820cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Views.vue"
export default component.exports